"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));
var _MessageContext = _interopRequireDefault(require("../../context/MessageContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MessageRoot = _ref => {
  let {
    autoHideDuration = 2000,
    children,
    position = "left"
  } = _ref;
  const [messageObj, setMessageObj] = (0, _react.useState)({});
  const [open, setOpen] = (0, _react.useState)(false);
  const {
    message,
    type
  } = messageObj || {};
  (0, _react.useEffect)(() => {
    setOpen(!(0, _isEmpty.default)(messageObj));
  }, [messageObj]);
  return /*#__PURE__*/_react.default.createElement(_MessageContext.default.Provider, {
    value: {
      messageObj,
      setMessageObj
    }
  }, children, /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: position
    },
    autoHideDuration: autoHideDuration,
    open: open,
    onClose: () => setOpen(false)
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    severity: type
  }, message)));
};
var _default = exports.default = MessageRoot;